var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVitals(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(-18 5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1141",
    "data-name": "Rectangle 1141",
    width: 32,
    height: 32,
    transform: "translate(18 -5)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4556",
    "data-name": "Path 4556",
    d: "M19.792,5a6.113,6.113,0,0,0-2.053-3.257A5.4,5.4,0,0,0,14.345.5a5.013,5.013,0,0,0-2.619.739A6.261,6.261,0,0,0,10,2.811,5.427,5.427,0,0,0,5.656.5,5.4,5.4,0,0,0,2.263,1.746,6.114,6.114,0,0,0,.21,5a7.288,7.288,0,0,0,.126,3.92H3.364L4.457,6.737a.586.586,0,0,1,1.048,0l1.986,3.972L9.477,6.737a.586.586,0,0,1,1.048,0l1.093,2.186H15.7a.586.586,0,0,1,0,1.172H11.256a.586.586,0,0,1-.524-.324L10,8.309,8.015,12.281a.586.586,0,0,1-1.048,0L4.981,8.309,4.25,9.771a.586.586,0,0,1-.524.324H.776A11.186,11.186,0,0,0,1.5,11.442c1.595,2.543,4.36,4.9,8.217,7a.586.586,0,0,0,.561,0c3.859-2.1,6.625-4.461,8.22-7A8.109,8.109,0,0,0,19.792,5Zm0,0",
    transform: "translate(23.999 1.482)",
    fill: "#09c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVitals);
export default __webpack_public_path__ + "static/media/vitals.5ce11725818dbcf2e733528aa6a712b2.svg";
export { ForwardRef as ReactComponent };